import { lazy } from "react";

export type { IShareGifMenuProps } from "./types";

export const ShareGifMenu = lazy(() => import("./ShareGifMenu"));
